const getUrlVars = () => {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value;
    });
    return vars;
};

const init = () => {
    const priority = getUrlVars().priority;
    const validPriority = typeof priority !== 'undefined' && priority !== '';

    if (validPriority) {
        window.mapiUtils.updateRequestPriority(priority);
    }
};

export { init };
